import HCRender from "../hc-render"

const BreadcrumbsSection = ({ items = [] }) => {
  const Breadcrumbs = HCRender.getFragment("Breadcrumbs")

  return (
    <div className="flex-shrink-0">
      <div className="w-full max-w-w2_xl flex items-center py-5 md:py-9 lg:py-12 xl:py-14 mx-auto">
        {Breadcrumbs && <Breadcrumbs items={items} />}
      </div>
    </div>
  )
}

export default BreadcrumbsSection
